import { render, staticRenderFns } from "./orderSendButton.vue?vue&type=template&id=22099aa6&"
import script from "./orderSendButton.vue?vue&type=script&lang=js&"
export * from "./orderSendButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports